import { UrlSegments } from 'src/app/jurisdiction/jurisdiction.constants';
import { RegepTechnicalSpecificationsSectionsState } from '../entities/sections-state/regepTechnicalSpecificationsSectionsState';
import { Observable } from 'rxjs';
import { PersonalDataSectionsState } from 'src/app/+grid-application-shared/entities/sections-state/personalDataSectionsState';
import { DocumentsSectionsState } from 'src/app/+grid-application-shared/entities/sections-state/documentsSectionsState';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { CommunicationService } from 'src/app/services/communication.service';
import { Injectable } from '@angular/core';
import { RegepRegulatoryDataSectionsState } from '../entities/sections-state/regepRegulatoryDataSectionsState';

@Injectable({
  providedIn: 'root',
})
export class RegepCommentsService extends GridApplicationCommentsService {
  constructor(private readonly communicationService: CommunicationService) {
    super();
  }

  public createTechnicalSpecificationsSectionComment(updateRequest: RegepTechnicalSpecificationsSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepTechnicalSpecificationsSectionComment, updateRequest);
  }

  public updateTechnicalSpecificationsSectionComment(updateRequest: RegepTechnicalSpecificationsSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.RegepTechnicalSpecificationsSectionComment, updateRequest);
  }

  public createPersonalDataSectionComment(updateRequest: PersonalDataSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepPersonalDataSectionComment, updateRequest);
  }

  public updatePersonalDataSectionComment(updateRequest: PersonalDataSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.RegepPersonalDataSectionComment, updateRequest);
  }

  public createDocumentsSectionComment(updateRequest: DocumentsSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepDocumentsSectionComment, updateRequest);
  }

  public updateDocumentsSectionComment(updateRequest: DocumentsSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.RegepDocumentsSectionComment, updateRequest);
  }

  public createRegulatoryDataSectionComment(updateRequest: RegepRegulatoryDataSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepRegulatorySectionComment, updateRequest);
  }

  public updateRegulatoryDataSectionComment(updateRequest: RegepRegulatoryDataSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.RegepRegulatorySectionComment, updateRequest);
  }
}
